import type { StringMap } from 'corgi-types';
import { omit } from 'lodash-es';

const COUPON_STORAGE_KEY = 'online-coupons-store';

const getSavedCoupons = (): StringMap<boolean> => {
  try {
    return JSON.parse(window.localStorage.getItem(COUPON_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
};

export const resetCouponInStorage = (sku: string) => {
  let coupons = getSavedCoupons();
  coupons = omit(coupons, sku);
  window.localStorage.setItem(COUPON_STORAGE_KEY, JSON.stringify(coupons));
};

export const saveCouponInStorage = (sku: string, activated: boolean) => {
  let coupons = getSavedCoupons();
  if (activated) {
    coupons[sku] = activated;
  } else {
    coupons = omit(coupons, sku);
  }
  window.localStorage.setItem(COUPON_STORAGE_KEY, JSON.stringify(coupons));
};

export const getIsCouponActivated = (sku: string) => {
  const coupons = getSavedCoupons();

  return !!coupons[sku];
};
